/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function InfoIcon({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon-info">
        <g id="Group 78">
          <g id="Group 76 Copy 2">
            <g id="Group 74 Copy 2">
              <g id="Group 72 Copy 2">
                <g id="Group 70 Copy 2">
                  <g id="Group 68 Copy 2">
                    <g id="Group 66 Copy 2">
                      <g id="Group 65 Copy 2">
                        <g id="Group 63 Copy 2">
                          <g id="Group 61 Copy 2">
                            <g id="Group 59 Copy 3">
                              <g id="icon-legal and finance copy">
                                <g id="Group 58 Copy 2">
                                  <g id="icon-journey-course">
                                    <circle
                                      id="Oval"
                                      cx="78.5"
                                      cy="78.5"
                                      r="77.5"
                                      fill={mainColor}
                                      stroke="white"
                                      stroke-width="2"
                                    />
                                  </g>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g id="info-button copy">
            <path
              id="Shape"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M106.993 49.008C90.9818 32.9982 65.0214 32.9964 49.008 49.008C32.9964 65.0196 32.9982 90.98 49.008 106.993C65.0196 123.001 90.98 123.003 106.993 106.993C123.003 90.98 123.001 65.0214 106.993 49.008ZM83.3468 95.827C83.3468 98.7808 80.9527 101.175 77.9989 101.175C75.0451 101.175 72.651 98.7808 72.651 95.827V74.4354C72.651 71.4816 75.0451 69.0875 77.9989 69.0875C80.9527 69.0875 83.3468 71.4816 83.3468 74.4354V95.827ZM72.8346 60.4186C72.7704 63.1122 74.824 65.2941 77.9044 65.2941C81.1131 65.2941 83.1649 63.1122 83.1667 60.4186C83.1008 57.5967 81.1114 55.4789 77.9668 55.4789C74.824 55.4789 72.7704 57.5949 72.8346 60.4186Z"
              fill={secondaryColor}
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

InfoIcon.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
InfoIcon.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};

const memoized = React.memo(InfoIcon);
memoized.displayName = 'InfoIcon';
export default memoized;
